import intermind from '../../index';
import { GoogleResource } from './resources/google';
import { CalendarEvent } from './types/event';

export class CalendarResource {
  private readonly googleResource: GoogleResource;

  constructor() {
    this.googleResource = new GoogleResource();
  }

  get google() {
    return this.googleResource;
  }

  async events(): Promise<CalendarEvent[]> {
    const { data } = await intermind.httpClient.get<CalendarEvent[]>('/calendar/events');
    return data;
  }

  async upcomingEvents(): Promise<CalendarEvent[]> {
    const { data } = await intermind.httpClient.get<CalendarEvent[]>('/calendar/events/upcoming');
    return data;
  }
}
